import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { Box, Link, Typography } from '@mui/material'

// The one not-found page, for any unknown address (ErrorsController) and an
// unknown article. `children` are extra links, shown under the home link.
export default function NotFound({ children }) {
  React.useEffect(() => {
    document.title = 'Not found - Stikis'
  }, [])

  return (
    <Box sx={{ width: '100%', maxWidth: 700 }}>
      <Typography component='h1' variant='h4' gutterBottom>
        Not found
      </Typography>
      <Typography variant='body1'>
        There is nothing at this address.
      </Typography>
      <Typography variant='body2' sx={{ mt: 4 }}>
        {/* /app goes to the welcome page, or to your last page if signed in */}
        <Link component={RouterLink} to='/app'>
          Go to Stikis
        </Link>
      </Typography>
      {children}
    </Box>
  )
}
